import React from "react";
import Layout from "../../components/Layout";

const PaymentErrorPage = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-surface-50 flex items-center justify-center px-6 pt-20">
        <div className="max-w-md w-full text-center">
          {/* Icon */}
          <div className="mx-auto mb-8 w-24 h-24 rounded-full bg-gradient-to-br from-red-400 to-red-600 flex items-center justify-center shadow-xl shadow-red-500/25">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

          <h1 className="text-3xl font-extrabold text-surface-900 mb-3">Ödəniş baş tutmadı</h1>
          <p className="text-surface-500 leading-relaxed mb-8">
            Təəssüf ki, ödəniş zamanı xəta baş verdi. Lütfən bağlantınızı və kart məlumatlarınızı yoxlayın.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-3">
            <a
              href="/"
              className="inline-flex items-center justify-center gap-2 bg-surface-900 text-white font-semibold px-8 py-4 rounded-2xl hover:bg-surface-800 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182" />
              </svg>
              Yenidən cəhd et
            </a>
            <a
              href="/"
              className="inline-flex items-center justify-center gap-2 bg-white text-surface-700 font-semibold px-8 py-4 rounded-2xl border border-surface-200 hover:bg-surface-50 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
              </svg>
              Ana səhifə
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PaymentErrorPage;
